// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"323817a0","239":"74c1607d","750":"368e7f79"}[chunkId] + ".chunk.js";
};